import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQueryWithTokenRefresh } from '../../common/baseQuery'
import { Notice, NoticeKey } from '../../models/Notice'
import { BaseRequest, BaseResponse } from '../models'

const _BASE_URL = import.meta.env.REACT_APP_GROWTH_SUPPORT_API_BASE_URL!

export interface UpdateNoticeRequest extends BaseRequest {
  key: NoticeKey
  isDismissed: boolean
}

export const noticesApi = createApi({
  reducerPath: 'noticesApi',
  baseQuery: baseQueryWithTokenRefresh(_BASE_URL),
  tagTypes: ['Notices'],
  endpoints: (builder) => ({
    getNotices: builder.query<BaseResponse<Notice[]>, BaseRequest>({
      query: (request) => ({
        url: `/accounts/${request.accountId}/notices/`,
      }),
      providesTags: ['Notices'],
    }),
    updateNotice: builder.mutation<BaseResponse<Notice>, UpdateNoticeRequest>({
      query: (request) => ({
        url: `/accounts/${request.accountId}/notices/${request.key}`,
        method: 'PUT',
        body: { isDismissed: request.isDismissed },
      }),
      invalidatesTags: ['Notices'],
    }),
  }),
})

export const { useGetNoticesQuery, useUpdateNoticeMutation } = noticesApi
